module.exports = __webpack_public_path__ + "static/belt_of_dwarvenkind-d99cdada2b466870819f3c8c3b43a00a.jpeg";